// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DialogModal__dialog___HoW4t {
    width: 32rem;
    border-radius: 0.4rem;
}

.DialogModal__button___ThH6x {
    width: var(--dialog-modal-button-width, 10rem);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Modals/DialogModal/DialogModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,8CAA8C;AAClD","sourcesContent":[".dialog {\n    width: 32rem;\n    border-radius: 0.4rem;\n}\n\n.button {\n    width: var(--dialog-modal-button-width, 10rem);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `DialogModal__dialog___HoW4t`,
	"button": `DialogModal__button___ThH6x`
};
export default ___CSS_LOADER_EXPORT___;
